import Axios from 'axios'
import { constants } from '@/config/constant'

const getShow = async (context) => {
    const url = constants.base_url + '/v1/show/all'
    let response = await Axios.get(url)

    if(response.data.status){
        context.commit('SET_SHOW', response.data)
    }

    return response.data
}

const createShow = async (context, payload) => {
    const url = constants.base_url + '/v1/show/create'
    let response = await Axios.post(url, payload, {headers:{'Content-Type': 'multipart/form-data'}})

    return response.data
}

const updateShow = async (context, payload) => {
    const url = constants.base_url + '/v1/show/update/' + payload.id
    let response = await Axios.post(url, payload.data, {headers:{'Content-Type': 'multipart/form-data'}})

    return response.data
}

const deleteShow = async (context, payload) => {
    const url = constants.base_url + '/v1/show/delete/' + payload
    let response = await Axios.delete(url)

    return response.data
}

const resetShowForm = async (context) => {
    context.commit('RESET_SHOW_FORM')
}

export {
    getShow,
    createShow,
    updateShow,
    deleteShow,
    resetShowForm,
}